import React, { Component } from 'react';

class ForBusiness extends Component {
  render() {
    return (
      <div className="container-fluid">
  <div className="row">
    <div className="col">
      <h1 style={{backgroundColor: 'gray', padding: 70}}>Hello. You are in "FOR BUSINESS" page!</h1>
    </div>
  </div>
</div>

    );
  }
}

export default ForBusiness;